import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'bw-prominent-cell-legacy',
    templateUrl: './prominent-cell.component.html',
    styleUrls: ['./prominent-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProminentCellComponentLegacy {
  @Input() label: string;
  @Input() value: string | number;
  @Input() disabled = false;
  @Input() nested = false;
  /** When true, shows a bottom border (e.g. between nested list items). Off by default. */
  @Input() showBottomBorder = false;
  @Output() cellClick = new EventEmitter<void>();

  onCellClick(): void {
    if (!this.disabled) {
      this.cellClick.emit();
    }
  }
}
